import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { ScopeProvider } from "./scope/ScopeContext";
import { LoginPage } from "./pages/LoginPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { AppLayout } from "./pages/AppLayout";
import { ReviewsQueuePage } from "./pages/ReviewsQueuePage";
import { TemplatesPage } from "./pages/TemplatesPage";
import { CalendarPage } from "./pages/CalendarPage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { OnboardingGbpPage } from "./pages/OnboardingGbpPage";
import { FunnelPage } from "./pages/FunnelPage";
import { OutreachSettingsPage } from "./pages/OutreachSettingsPage";
import { OutreachApprovalPage } from "./pages/OutreachApprovalPage";
import { OutreachRecipientDetailPage } from "./pages/OutreachRecipientDetailPage";
import { OutreachReportingPage } from "./pages/OutreachReportingPage";
import { OutreachFeedbackInboxPage } from "./pages/OutreachFeedbackInboxPage";
import { OutreachRecognitionPage } from "./pages/OutreachRecognitionPage";
import { UpsPage } from "./pages/UpsPage";
import { OsmListingsPage } from "./pages/OsmListingsPage";

export function App() {
  return (
    <AuthProvider>
      <ScopeProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Locked-out recovery — necessarily unauthenticated. The reset link's
              token arrives in the query string because email has no other
              channel; it is single-use and expires in an hour. */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Public customer feedback funnel — no auth. */}
          <Route path="/r/:token" element={<FunnelPage />} />
          <Route
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/reviews" replace />} />
            <Route path="/reviews" element={<ReviewsQueuePage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/admin/integrations" element={<IntegrationsPage />} />
            <Route path="/admin/osm" element={<OsmListingsPage />} />
            <Route path="/outreach" element={<OutreachReportingPage />} />
            <Route path="/outreach/queue" element={<OutreachApprovalPage />} />
            <Route path="/outreach/settings" element={<OutreachSettingsPage />} />
            <Route path="/outreach/feedback" element={<OutreachFeedbackInboxPage />} />
            <Route path="/outreach/recognition" element={<OutreachRecognitionPage />} />
            <Route path="/outreach/recipients/:id" element={<OutreachRecipientDetailPage />} />
            <Route path="/ups" element={<UpsPage />} />
            <Route path="/onboarding/gbp" element={<OnboardingGbpPage />} />
            <Route path="/onboarding/gbp/select" element={<OnboardingGbpPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ScopeProvider>
    </AuthProvider>
  );
}
